import { render, staticRenderFns } from "./SeguradoraForm.vue?vue&type=template&id=32e97206"
import script from "./SeguradoraForm.vue?vue&type=script&lang=js"
export * from "./SeguradoraForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports